import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { APP_ROUTERS } from "@/constants/app-routers";
import { maskSearchFragment } from "@/features/shared/route-masking";

/**
 * The founding-member presale was dropped (2026-11-02), but its links still circulate in
 * campaign emails and ads: `/presale` and every step under it (`/presale/sign-up`,
 * `/presale/checkout`, …). This one catch-all sends them all to the normal sign-up.
 *
 * The offer, coupon, referral and UTM params carry over under the names the normal sign-up
 * reads — the same hand-off a signed-out visit to `/my/checkout/<checkoutLinkId>` gets — so
 * the visitor still lands on the offer they clicked. Lenient on purpose: a strict schema on
 * a URL param would crash the page instead of redirecting.
 */
const searchSchema = z.object({
  /** `CheckoutLink.id` of the presale offer; the normal sign-up calls it `checkoutId`. */
  checkoutLinkId: z.string().optional(),
  discountCode: z.string().optional(),
  referId: z.string().optional(),
  referredBy: z.string().optional(),
  utm_source: z.string().optional(),
  utm_medium: z.string().optional(),
  utm_campaign: z.string().optional(),
  ...maskSearchFragment,
});

export const Route = createFileRoute("/(member)/(public)/presale/$")({
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    throw redirect({
      to: APP_ROUTERS.JOIN_STEP_SIGN_UP,
      search: {
        checkoutId: search.checkoutLinkId,
        discountCode: search.discountCode,
        referId: search.referId,
        referredBy: search.referredBy,
        utm_source: search.utm_source,
        utm_medium: search.utm_medium,
        utm_campaign: search.utm_campaign,
        addOns: [],
      },
      // Without `replace`, Back from the sign-up returns here and redirects forward again.
      replace: true,
    });
  },
});
